import {ITextValue} from '@/interfaces/key-value-interface';

export const getLabelFactory = <T>(lst: ITextValue<T>[]): (item: T) => string =>
    item => lst.findOrFirst(x => x.value === item).text;
